import { graphql } from "react-relay";

export const TREE_NODE_FRAGMENT = graphql`
	fragment startContentConfigEditor_TreeNodeFragment on TreeNode {
		id
		typeDefinition {
			... on ELearningContentTypeDefinition {
				startConfigs {
					id
					configType
					... on CanNDaysAfterStartingTreeStartContentConfig {
						days
					}
				}
			}
		}
	}
`;

export const REMOVE_START_CONTENT_CONFIGURATION_MUTATION = graphql`
	mutation startContentConfigEditor_RemoveStartContentConfigMutation(
		$input: RemoveStartContentConfigInput!
	) {
		Admin {
			Tree {
				removeStartContentConfig(input: $input) {
					contentNode {
						...startContentConfigEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;
export const ADD_CAN_AFTER_STARTING_TREE_START_CONTENT_CONFIG_MUTATION = graphql`
	mutation startContentConfigEditor_addCanAfterStartingTreeStartContentConfigAdminMutation(
		$input: AddCanAfterStartingTreeStartContentConfigInput!
	) {
		Admin {
			Tree {
				addCanAfterStartingTreeStartContentConfig(input: $input) {
					clientMutationId
					content {
						...startContentConfigEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;

export const ADD_CAN_IF_UNLOCKED_START_CONTENT_CONFIG_MUTATION = graphql`
	mutation startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation(
		$input: AddCanIfUnlockedStartContentConfigInput!
	) {
		Admin {
			Tree {
				addCanIfUnlockedStartContentConfig(input: $input) {
					clientMutationId
					content {
						...startContentConfigEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;

export const ADD_CAN_SKIP_START_CONTENT_CONFIG_MUTATION = graphql`
	mutation startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation(
		$input: AddCanAfterNDaysStartingTreeStartContentConfigInput!
	) {
		Admin {
			Tree {
				addCanNDaysAfterStartingTreeStartContentConfig(input: $input) {
					content {
						id
						rootId
						typeDefinition {
							... on ELearningContentTypeDefinition {
								startConfigs {
									id
									configType
									... on CanNDaysAfterStartingTreeStartContentConfig {
										days
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const ADD_CAN_IF_CERTIFICATION_UNLOCKED_START_CONTENT_CONFIG_MUTATION = graphql`
	mutation startContentConfigEditor_addCanIfCertificationUnlockedStartContentConfigAdminMutation(
		$input: AddCanIfCertificationUnlockedStartContentConfigInput!
	) {
		Admin {
			Tree {
				addCanIfCertificationUnlockedStartContentConfig(input: $input) {
					clientMutationId
					content {
						...startContentConfigEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;
